var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92 0C0.859613 0 0 0.859613 0 1.92V14.08C0 15.1404 0.859613 16 1.92 16H14.08C15.1404 16 16 15.1404 16 14.08V1.92C16 0.859613 15.1404 0 14.08 0H1.92ZM4.79698 11.9204C4.95577 12 5.03517 12 5.19396 12C5.35275 12 5.43215 12 5.59094 11.9204L11.1487 8.73632C11.3868 8.57712 11.5456 8.33831 11.5456 8.0199C11.5456 7.70149 11.3868 7.46269 11.1487 7.30348L5.59094 4.1194C5.35275 3.9602 5.03517 3.9602 4.79698 4.1194C4.55879 4.27861 4.4 4.51741 4.4 4.83582V11.204C4.4 11.5224 4.55879 11.7612 4.79698 11.9204ZM9.16375 8.0199L5.98792 9.85075V6.18905L9.16375 8.0199Z",
    fill: "#844FDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.0148e1c0dbc4e1a9ce82f6e6235a99c6.svg";
export { ForwardRef as ReactComponent };